import * as R from 'ramda'

import {
  buildExtraFromFlatRule,
  getFlatRuleDiscriminator,
  getRuleDiscriminator,
} from 'libs/filter-rule-discriminator'

export function convertAnswerFilterResponseToRules(answerFilter, options) {
  if (R.prop('global_operator', answerFilter)) {
    return answerFilter?.groups?.map((group) => ({
      operator: group.operator,
      rules: group?.filters?.map((rule) => {
        const hasFilters = !R.isEmpty(R.prop('filters', rule))
        const filters = hasFilters ? rule.filters : _mapRuleToFilter(rule)
        const selectedOption = findSelectedOption(rule, options)
        const extra = buildExtraFromFlatRule(rule)
        return {
          ...selectedOption,
          extra,
          filters,
        }
      }),
    }))
  } else if (R.prop('and', answerFilter)) {
    return answerFilter?.and?.map((rule) => {
      const hasFilters = !R.isEmpty(R.prop('filters', rule))
      const filters = hasFilters ? rule.filters : _mapRuleToFilter(rule)
      const selectedOption = findSelectedOption(rule, options)
      const extra = buildExtraFromFlatRule(rule)
      return {
        ...selectedOption,
        extra,
        filters,
      }
    })
  } else {
    return []
  }
}

function _mapRuleToFilter(rule) {
  const filters = rule?.filtered_values?.map((filtered_value) => {
    return { value: filtered_value, label: filtered_value }
  })
  return filters
}

function findSelectedOption(rule, options) {
  let selected_option = null
  if (rule.key === 'topic.pair.sentiment') {
    selected_option = R.find((option) => option.field === 'topic.pair.sentiment', options)
  } else {
    const value = `${rule.key}${getFlatRuleDiscriminator(rule)}`
    selected_option = R.find((option) => {
      const optionValue = `${R.prop('field', option)}${getRuleDiscriminator(option)}`
      return value === optionValue
    }, options)
  }

  if (selected_option && rule.comparison) {
    selected_option['comparison'] = rule.comparison
  }
  return selected_option
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/convertAdvanceFilter/utils.js